import { Box, List, styled } from "@mui/material";

export const AttachmentUploadContainer = styled(Box)`
  display: flex;
  justify-content: space-around;
  overflow-y: auto;
  height: 100%;
`;
export const AttachmentUploadProgress = styled(Box)`
  position: sticky;
  top: 0;
`;
export const AttachmentUploadList = styled(List)`
  width: 100%;
  padding: 0;
`;
